/**
 * Copyright © 2026 Adnuntius AS.
 */
import {ApiConfig} from '../../api';
import {AdnHttpService} from '../../../util/adn-http.service';
import {createAdnHttpResource, createAdnHttpResourceSender} from '../../../util/create-adn-http-resource';
import {LocalUserProfile} from '../../../session/local-user-profile';
import {AuthHttpInterceptorService} from '../../../auth/auth-http-interceptor.service';
import {ApiErrorHandlerService} from '../../../../app/common/directives/error/api-error-handler.service';

/** Angular DI token for the TeamGroup HTTP resource (factory product). */
export class TeamGroupResource {
}

export function createTeamGroupResource(
  AdnHttp: AdnHttpService,
  authHttpInterceptor: AuthHttpInterceptorService,
  ApiErrorHandler: ApiErrorHandlerService,
  localUserProfile: LocalUserProfile
): any {
  const send = createAdnHttpResourceSender(AdnHttp, authHttpInterceptor, ApiErrorHandler);
  const TeamGroup: any = createAdnHttpResource(send, 'teamgroups', () => localUserProfile, 'teamGroup');
  const uri = ApiConfig.obtain().getVersionedUri('teamgroups');

  TeamGroup.updateTeamGroup = function(params: any): any {
    return {
      $promise: send({
        method: 'POST',
        url: uri + '/' + encodeURIComponent(params.id) + '/' + encodeURIComponent(params.teamId),
        body: {}
      })
    };
  };

  TeamGroup.updateTeamToTeamGroup = function(teamGroupId: any, teamId: any, removeOnly: any): void {
    TeamGroup.updateTeamGroup({id: teamGroupId, teamId, removeOnly: !!removeOnly});
  };

  return TeamGroup;
}

export const teamGroupResourceProvider = {
  provide: TeamGroupResource,
  useFactory: createTeamGroupResource,
  deps: [AdnHttpService, AuthHttpInterceptorService, ApiErrorHandlerService, LocalUserProfile]
};

